<template>
    <div class="page-container">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">工单处理</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>运营人员工单</el-breadcrumb-item>
        </el-breadcrumb>
        <work />

    </div>
</template>

<script>
    import './api';
    import './store';
    import work from "./components/work";
    import userInfoHelper from 'common/userInfo';

    export default {
        name: 'DevelopUser',
        data() {
            return {};
        },
        components: {work},
        methods: {
            getUserName() {
                return userInfoHelper.get().userName;
            },
            isDevelop() {
                return  false;
            },

        },
        created() {
        }
    };
</script>

<style lang="less" scoped>
</style>
